var map = {
	"./add.svg": "b280",
	"./add_header.svg": "9980",
	"./checklist.svg": "2961",
	"./close.svg": "8da2",
	"./download.svg": "052e",
	"./download_header.svg": "022f",
	"./edit.svg": "d8c1",
	"./edit_header.svg": "438e",
	"./file_header.svg": "e07b",
	"./filters_header.svg": "2a7e",
	"./more_filters.svg": "995b",
	"./project_filter.svg": "7292",
	"./show.svg": "c117",
	"./show_header.svg": "1e7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5c0";